import React from 'react';
import { motion } from 'framer-motion';
export function CheMenuScreen() {
  return <section className="min-h-screen w-full bg-white flex flex-col items-center justify-center px-6 py-20" data-id="element-57">
      <motion.div initial={{
      opacity: 0,
      y: 40
    }} whileInView={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} viewport={{
      once: true,
      margin: '-100px'
    }} className="w-full max-w-5xl" data-id="element-58">
        <h2 className="text-3xl md:text-4xl font-bold text-purple-700 text-center mb-10" data-id="element-59">
          Menu & Episode Branching
        </h2>
        <div className="rounded-2xl overflow-hidden shadow-lg border border-slate-200" data-id="element-60">
          <img src="https://cdn.magicpatterns.com/uploads/cb8Q4Vyo419jgKef6aa77T/Screenshot_2026-04-09_at_11.47.48.png" alt="Menu structure showing Let's Dive Deeper CTA branching into CHE 2, CHE 3, and CHE 4 episodes" className="w-full h-auto" data-id="element-61" />
        </div>
      </motion.div>
    </section>;
}